var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header d-flex align-items-center pb-2"},[_c('ReturnLink',{staticClass:"start fs-20"}),_vm._t("default",function(){return [_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("afterTitile")]}),_c('div',{staticClass:"end"},[_c('div',{staticClass:"d-flex gap-2 align-items-center"},[_vm._t("end")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }